export const ProjectActionTypes = {
    SET_PROJECT_LIST: "SET_PROJECT_LIST",
    SET_PAGINATED_PROJECT_LIST: "SET_PAGINATED_PROJECT_LIST",
    SET_FILTERED_LIST: 'SET_FILTERED_LIST',
    UPDATE_PROJECT_ACTIVE: 'UPDATE_PROJECT_ACTIVE',
    SET_PROJECT_FILTER_LIST: 'SET_PROJECT_FILTER_LIST'
}